import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useInvoiceSettings = () => {

    //PARAMS
    const history = useHistory();
    const { idBranch } = useParams();

    //#region DISPLAY MESSAGE
    const [ createSweet ] = useSweetAlert();
    //#endregion

    //#region MODALS    
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [method, setMethod] = useState("");
    const [loading, setLoading] = useState(false);
    // ? Modal
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);

    const openDialog = (title, mode) => {
        // setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);   
    };

    //#endregion

    //#region INVOICE SETTINGS

        //#region INVOICE SETTINGS MODELS
        const [viewFormFilters, setViewFormFilters] = useState(false);
        const [idInvoiceSettings, setIdInvoiceSettings] = useState(null);
        const [filterTypeDocument, setFilterTypeDocument] = useState(0);
        const [filterByStatus, setFilterByStatus] = useState("");
        
        const [reloadMethods, setReloadMethods] = useState(false);
        
        const [listInvoiceSettings, setListInvoiceSettings] = useState([]);
        const [listTypeDocuments, setListTypeDocuments] = useState([]);

        const [searchInvoiceSettings, setSearchInvoiceSettings] = useState("");
        const [invoiceSettingsData, setInvoiceSettingsData] = useState([]);

        const [formValues, handleInputChange, reset, handleUpdateValues] = useForm(
            {
                id_type_document: 0,
                code: "",
                serie: "",
                initial_folio: 1,
                final_folio: 0,
                is_default: false,
                is_fiscal: false
            }
        );

        const {
            id_type_document, code, serie, initial_folio, final_folio, is_default, is_fiscal
        } = formValues;
        //#endregion

        //#region VALIDATIONS
        const [validationInvoiceSettings, setValidationInvoiceSettings] = useState(
            {
                id_type_document_valid: false,
                code_valid: false,
                serie_valid: false,
                initial_folio_valid: false,
                final_folio_valid: false,                
            }
        )
        //#endregion

        //#region USE EFFECTS
        useEffect(() => {          
            getListInvoiceSettings();
            getListTypeDocument();
        }, []);

        useEffect(() => {
            
            if (reloadMethods) {
                getListInvoiceSettings();
            }

        }, [reloadMethods]);
        
        
        //#endregion
        
        //#region INVOICE SETTINGS METHODS
        const handleViewFilters = () => {
            setViewFormFilters(!viewFormFilters);
        }

        const getListInvoiceSettings = async () => {
            let list = await handleRequest("GET", `SettingsSeriesFolios/List/${idBranch}`, "Configuración de series");

            if (list !== null && list.length > 0) {

                ////console.log(list);

                setListInvoiceSettings(list);
                setInvoiceSettingsData(list);
                setReloadMethods(false);
            }
            else {
                setReloadMethods(false);
            }
        }

        const getListTypeDocument = async () => {
            let list = await handleRequest("GET", "CfdiCatalog/ListTypeDocument", "Lista de tipos de documentos");

            if (list !== null && list.length > 0) {
                setListTypeDocuments(list);
            }
        }

        const handleChangeFilterTypeDocument = (e) =>{ 
            let value = e.target.value;

            setFilterTypeDocument(value);
        }

        const handleAddInvoiceSettings = () => {
            setModalTitle("Nueva serie y folio");
            
            handleUpdateValues(
                {
                    id_type_document: 0,
                    code: "",
                    serie: "",
                    initial_folio: 1,
                    final_folio: 0,
                    is_default: false,
                    is_fiscal: false
                }
            );

            setValidationInvoiceSettings({
                id_type_document_valid: false,
                code_valid: false,
                serie_valid: false,
                initial_folio_valid: false,
                final_folio_valid: false,      
            });

            setMethod("create");
            openDialog("Crear serie y folio", "create");
        }

        const saveCreate = async (e) => {
            e.preventDefault();

            setLoading(true);

            if (validInvoiceSettings()) {
                setLoading(false);
                return;
            }

            let body = {
                ...formValues,
                id_branch: idBranch
            };

            const response = await handleRequest("POST", "SettingsSeriesFolios/Create", "Crear configuración", body);

            if (response !== null) {
                createSweet("create", "success", "Exito!", "La serie y el folio se agregaron con exito!");
                setReloadMethods(true);
                closeDialog();
            }
            else {
                setLoading(false);
            }
        }

        const handleUpdate = (id_invoice_settings) => {
            setIdInvoiceSettings(id_invoice_settings);

            let findInvoiceSettings = listInvoiceSettings.find(x => x.id_invoice_settings == id_invoice_settings);

            if (findInvoiceSettings !== undefined) {
                
                handleUpdateValues({
                    id_type_document: findInvoiceSettings.id_type_document,
                    code: findInvoiceSettings.code,
                    serie: findInvoiceSettings.serie,
                    initial_folio: findInvoiceSettings.initial_folio,
                    final_folio: findInvoiceSettings.final_folio,
                    is_default: findInvoiceSettings.is_default,
                    is_fiscal: findInvoiceSettings.is_fiscal
                });

                setValidationInvoiceSettings({
                    id_type_document_valid: false,
                    code_valid: false,
                    serie_valid: false,
                    initial_folio_valid: false,
                    final_folio_valid: false,     
                });

                setModalTitle("Editar serie y folio");
                openDialog("Editar serie y folio", "update");
                setMethod("update");
            }
        }

        const saveUpdate = async (e) => {
            e.preventDefault();

            setLoading(true);

            if (validInvoiceSettings()) {
                setLoading(false);
                return;
            }

            let body = {
                ...formValues,
                id_invoice_settings: idInvoiceSettings,
                id_branch: idBranch
            };

            const response = await handleRequest("PUT", "SettingsSeriesFolios/Update", "Actualizar serie y folio", body);

            if (response !== null) {
                createSweet("update", "success", "Exito!", "La serie y el folio se actualizaron con exito!");
                setReloadMethods(true);
                setLoading(false);
                closeDialog();
            }
            else {
                setLoading(false);
            }
        }

        const handleDelete = (id_invoice_settings) => {
            setIdInvoiceSettings(id_invoice_settings);

            let findSettings = listInvoiceSettings.find(x => x.id_invoice_settings === id_invoice_settings);

            if (findSettings !== undefined) {
                handleUpdateValues({
                    code: findSettings.code,
                    serie: findSettings.serie,
                    initial_folio: findSettings.initial_folio
                });

                setMethod("delete");
                setModalTitle("Eliminar serie y folio");
                openDeleteAlert();
            }
        }

        const saveDelete = async (e) => {
            e.preventDefault();

            setLoading(true);

            const response = await handleRequest("DELETE", "SettingsSeriesFolios/"+idInvoiceSettings, "Eliminar series y folios");

            if (response !== null) {
                createSweet("delete", "success", "Exito!", "Se elimino la serie y el folio con exito!");
                setReloadMethods(true);
                closeDeleteAlert();
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        }
        //#endregion
    
    //#endregion

    //#region VALIDATIONS
    const validInvoiceSettings = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.id_type_document <= 0) {
            newValidations = {
                ...newValidations,
                id_type_document_valid: true
            };

            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                id_type_document_valid: false
            }
        }

        if (formValues.serie.length === 0) {
            newValidations = {
                ...newValidations,
                serie_valid: true
            };

            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                serie_valid: false
            };
        }

        if (formValues.initial_folio === "" || (formValues.initial_folio === 0 || formValues.initial_folio === "0")) {
            newValidations = {
                ...newValidations,
                initial_folio_valid: true
            };

            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                initial_folio_valid: false
            };
        }    
        
        setValidationInvoiceSettings(newValidations);

        return statusValidation;
    }
    //#endregion

    //GLOBAL REQUEST
    const handleRequest = async (method, methodUrl, nameMethod, body = null) =>
    {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }
        else if (response.code === 500) {
            createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");            
        }
        else {
            createSweet("warning", "warning", nameMethod, response.data.msg);
        }

        return null;
    }

    const handleSearchInvoiceSettings = (e) => {

        setSearchInvoiceSettings(e);

        let busqueda = e.toUpperCase();

        let newInvoiceSettings = [];

        if (busqueda === "") {

            setListInvoiceSettings([...invoiceSettingsData]);

        }
        else {

            invoiceSettingsData.forEach(element => {

                let typeDocument =
                    element.name_type_document?.toUpperCase() || "";

                let code =
                    element.code?.toUpperCase() || "";

                let serie =
                    element.serie?.toUpperCase() || "";

                if (
                    typeDocument.indexOf(busqueda) > -1 ||
                    code.indexOf(busqueda) > -1 ||
                    serie.indexOf(busqueda) > -1
                ) {

                    newInvoiceSettings.push(element);
                }
            });

            setListInvoiceSettings([...newInvoiceSettings]);
        }
    };

    const handleClearInvoiceSettings = () => {

        setSearchInvoiceSettings("");

        localStorage.removeItem("globalFilter");

        setListInvoiceSettings([...invoiceSettingsData]);
    };

    const handleExcelInvoiceSettings = async () => {

        setLoadingExport(true);

        try {

            const XLSX = await import("xlsx");

            const _report = listInvoiceSettings.map((item, index) => ({

                "#": index + 1,

                "Tipo documento":
                    item.name_type_document ?? "---",

                "Código":
                    item.code ?? "---",

                "Serie":
                    item.serie ?? "---",

                "Folio inicial":
                    item.initial_folio ?? "---",

                "Folio final":
                    item.final_folio ?? "---",

                "Por defecto":
                    item.is_default ? "SI" : "NO",

                "Fiscal":
                    item.is_fiscal ? "SI" : "NO",

                "Sucursal":
                    item.name_branch ?? "---"
            }));


            const worksheet =
                XLSX.utils.json_to_sheet(_report);

            worksheet["!cols"] = [

                { wch: 5 },
                { wch: 35 },
                { wch: 18 },
                { wch: 18 },
                { wch: 15 },
                { wch: 15 },
                { wch: 12 },
                { wch: 12 },
                { wch: 35 }
            ];


            const workbook =
                XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Series y folios"
            );


            const excelBuffer = XLSX.write(
                workbook,
                {
                    bookType: "xlsx",
                    type: "array"
                }
            );


            const dataBlob = new Blob(
                [excelBuffer],
                {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                }
            );


            const url =
                window.URL.createObjectURL(dataBlob);

            const link =
                document.createElement("a");

            link.href = url;

            link.download =
                "series_folios.xlsx";

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);

        }
        catch (error) {

            console.error(
                "Error exportando Excel",
                error
            );
        }

        setLoadingExport(false);
    };
    return {
        //MODALS SETTINGS
        modal, modalTitle, method, loading,

        closeDialog,

        //INVOICE SETTINGS MODELS
        viewFormFilters,listInvoiceSettings,
        filterTypeDocument,
        id_type_document, code, serie, initial_folio, final_folio, is_default, is_fiscal, validationInvoiceSettings,
        listTypeDocuments,

        //INVOICE SETTINGS METHODS
        handleInputChange, handleChangeFilterTypeDocument,
        handleViewFilters, 
        handleAddInvoiceSettings, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,         
        closeDeleteAlert, modalAlert, showDeleteAlert,
        handleClearInvoiceSettings, searchInvoiceSettings,
        handleSearchInvoiceSettings, loadingExport, handleExcelInvoiceSettings
    }
}
